import { render, staticRenderFns } from "./EvaluationReport.vue?vue&type=template&id=080b1ebc&scoped=true"
import script from "./EvaluationReport.vue?vue&type=script&lang=ts"
export * from "./EvaluationReport.vue?vue&type=script&lang=ts"
import style0 from "./EvaluationReport.vue?vue&type=style&index=0&id=080b1ebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080b1ebc",
  null
  
)

export default component.exports